
    export default 
    {
    "tutorial_over_modal": {
        "dec": "Bitte gehen Sie zu Shopify - Einstellungen - Auschecken, um zu überprüfen, ob Sie die automatische Ausführungsfunktion verwenden. Wenn ja, deaktivieren Sie sie bitte und speichern Sie die neuen Einstellungen.",
        "dec2": "Bitte beachten Sie, dass die Shopify-Auto-Fulfillment-Funktion die Bestellungen automatisch ausführt und verhindert, dass Sie sie an AliExpress weiterleiten. Wenn Sie diese Funktion auf Shopify aktiviert haben, können Sie keine Bestellungen auf DSers bearbeiten."
    }
}